// tsgolint types `Processor.use()` with transformer plugins as `error` (tsc resolves it fine), so
// every link of the unified chain below trips the no-unsafe-* rules.
/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call,
   @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return */
import {useMemo} from "react";
import * as prod from "react/jsx-runtime";
import rehypeReact from "rehype-react";
import breaks from "remark-breaks";
import remarkParse from "remark-parse";
import remarkRehype from "remark-rehype";
import {unified} from "unified";
import {documentStyles} from "./markdown.css";
import parialGfmMarkdownPlugin from "./parialGfmMarkdownPlugin";

const production = {Fragment: prod.Fragment, jsx: prod.jsx, jsxs: prod.jsxs};

type MarkdownProps = {
  children: string;
};
const Markdown = ({children}: MarkdownProps) => {
  const content = useMemo(() => {
    const processor = unified()
      .use(remarkParse)
      .use(parialGfmMarkdownPlugin)
      .use(breaks)
      .use(remarkRehype)
      .use(rehypeReact, production);
    return processor.processSync(children).result;
  }, [children]);
  return <div className={documentStyles.base}>{content}</div>;
};

export default Markdown;
